import React from 'react';

const PageLayout = ({ children, className = '', maxWidth = 'max-w-7xl' }) => {
  return (
    <div className={`w-full mx-auto px-1 sm:px-4 lg:px-6 pb-6 ${maxWidth} ${className}`}>
      {children}
    </div>
  );
};

export default PageLayout;
